import React from 'react';
import { withStyles } from "@mui/styles";
import {surveyCompletion} from "../ProfileExplorer";
import ColorGrid from "../../surveys/common/results/ColorGrid";

const styles = (theme) => ({
  survey:{
    display: "flex",
    flexDirection: "column",
    gap: "0 0.25rem",
    height: "100%",
  },
  surveyName:{
    width: "100%",
    margin: "1rem auto 0",
    textAlign: "center",
    fontWeight: 600
  },
  surveyCompletion:{
    margin: "0 auto",
    textAlign: "center",
    fontWeight: 500
  },
  surveyGridWrap: {
    display: 'flex',
    flex: 1,
  },
  surveyGridWrapMin: {
    minHeight: "33%",
  },
  surveyGrid: {
    zIndex: 1,
  },
});

function SurveyThumbnail(props) {
  const { item, iconSize, classes } = props;

  return (
    <div className={classes.survey}>
      <div className={classes.surveyName}>{item.item_data?.survey?.name||"Assessment"}</div>
      <div className={classes.surveyCompletion}>{surveyCompletion(item)}</div>
      <div className={`${classes.surveyGridWrap} ${iconSize === "Small" ? "" : classes.surveyGridWrapMin}`}>
        <ColorGrid
          className={classes.surveyGrid}
          noGap={iconSize === "Small"}
          surveyAttempt={item.item_data}
        />
      </div>
      {iconSize === "Small" || !item.description ? null : <div>{item.description}</div>}
    </div>
  );
}

export default withStyles(styles)(SurveyThumbnail);
